import React, {useRef} from 'react';
import {useDispatch} from 'react-redux';

import {cancelLogin, submitPassword} from 'modules/authentication/actions';

import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import ForgotPasswordLink from 'components/Authentication/Controls/ForgotPasswordLink';
import AuthenticationContainer from './AuthenticationContainer';
import PasswordField from 'components/Authentication/Controls/PasswordField';

export default function Password() {

    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const continueAction = () => {
        if (inputRef.current.value === '') {
            return;
        }

        dispatch(submitPassword(inputRef.current.value));
    };

    const cancelAction = () => {
        dispatch(cancelLogin());
    };

    return <AuthenticationContainer title="Login">
        <PasswordField inputRef={inputRef} autoFocus={true}/>
        <CancelAndContinueButtons cancelAction={cancelAction} continueAction={continueAction}/>
        <ForgotPasswordLink/>
    </AuthenticationContainer>;

}